import React, {memo, useEffect, useRef, useState} from "react";
import Container from "@mui/material/Container";
import {Box} from "@mui/material";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import {toast} from "react-toastify";
import {connect, useDispatch} from "react-redux";
import Button from "@mui/material/Button";
import { useParams } from "react-router-dom";
import {Paper} from "@mui/material";
import Api from "../../../utils/api";
import {Head} from "../../../components";
import {TOGGLE_CHECKED} from "../../../types";
import SunEditor, {buttonList} from "suneditor-react";


const ProductCategoryEdit = memo((props) => {


    const editor = useRef();

    const dispatch = useDispatch();

    const { id } = useParams();
    

    const initStat = {
        title: '',
        status: 1,
        deleted: 0,
        slug: '',
        meta_title: '',
        meta_description: '',
        content: '',
        has_link: 1,
    }

    const [form, setForm] = useState(initStat);
    const [loading, setLoading] = useState(false);

    useEffect(() => { // no async
        handleRequest();
    }, []);

    const getSunEditorInstance = (sunEditor) => {
        editor.current = sunEditor;
    };


    const handleRequest = () => {
        new Api().get('/products/filters/' + id).then((response) => {
            if (typeof response !== "undefined") {
                setForm(response);
            }
        })
    }


    const handleChangeElement = (event) => {

        let frm = form;

        if (event.target.name === 'title') {

            if (form.slug === '' || form.slug === frm['title'].split(' ').join('-')) {
                frm['slug'] = event.target.value.split(' ').join('-');
            }
            if (form.meta_title === ''  || form.meta_title  === frm['title']) {
                frm['meta_title'] = event.target.value;
            }
            if (form.meta_description === ''  || form.meta_description  === frm['title']) {
                frm['meta_description'] = event.target.value;
            }
        }

        frm[event.target.name] = event.target.value;
        setForm({...frm});
    };


    const handleSubmit = (event) => {

        event.preventDefault();

        setLoading(true);

        new Api().put('/products/filters/' + id, form).then((response) => {
            if (typeof response !== "undefined") {
                if (response.status) {
                    dispatch({type: TOGGLE_CHECKED, payload: []});
                    toast.success(response.msg);
                } else {
                    toast.error(response.msg);
                }
            }
            setLoading(false);
            handleRequest();
        })

    }



    return(
        <Container>
            <Head data={{ 'link': '/product/filter', 'title': 'ویرایش'}} />
            <Box mt={5}>
                <form onSubmit={handleSubmit}>
                    <Box mt={5}>
                        <Paper style={{ padding: '25px'}}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} >
                                    <TextField
                                        label="عنوان"
                                        variant="outlined"
                                        margin='dense'
                                        value={form.title}
                                        fullWidth
                                        name='title'
                                        onChange={handleChangeElement}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        select
                                        label="وضعیت"
                                        value={form.status}
                                        variant="outlined"
                                        margin='dense'
                                        fullWidth
                                        name='status'
                                        onChange={handleChangeElement}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    >
                                        <MenuItem value={1}>فعال</MenuItem>
                                        <MenuItem value={0}>غیرفعال</MenuItem>
                                    </TextField>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        select
                                        label="حذف"
                                        value={form.deleted}
                                        variant="outlined"
                                        margin='dense'
                                        fullWidth
                                        name='deleted'
                                        onChange={handleChangeElement}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    >
                                        <MenuItem value={1}>فعال</MenuItem>
                                        <MenuItem value={0}>غیرفعال</MenuItem>
                                    </TextField>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Box>
                    <Box mt={5}>
                        <Paper style={{ padding: '25px'}}>
                            <Grid container>
                                <Grid item xs={12} >
                                    <TextField
                                        label="اسلاگ"
                                        variant="outlined"
                                        margin='dense'
                                        value={form.slug}
                                        fullWidth
                                        name='slug'
                                        onChange={handleChangeElement}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        helperText='بدون فاصله وارد کنید.'
                                    />
                                </Grid>
                                <Grid item xs={12} >
                                    <TextField
                                        label="متا عنوان"
                                        variant="outlined"
                                        margin='dense'
                                        value={form.meta_title}
                                        fullWidth
                                        name='meta_title'
                                        onChange={handleChangeElement}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        helperText='60 تا 255 کاراکتر وارد کنید.'
                                    />
                                </Grid>
                                <Grid item xs={12} >
                                    <TextField
                                        label="متا توضیحات"
                                        variant="outlined"
                                        margin='dense'
                                        value={form.meta_description}
                                        fullWidth
                                        name='meta_description'
                                        onChange={handleChangeElement}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        helperText='60 تا 255 کاراکتر وارد کنید.'
                                    />
                                </Grid>
                            </Grid>
                        </Paper>
                    </Box>
                    <Box mt={5}>
                        <Paper style={{ padding: '25px'}}>
                            <Grid container>
                                <Grid item xs={12} style={{ margin: '20px 0'}}>
                                    <SunEditor
                                        setOptions={{
                                            height: 200,
                                            buttonList: buttonList.complex
                                        }}
                                        height="800px"
                                        getSunEditorInstance={getSunEditorInstance}
                                        defaultValue={form.content && form.content}
                                        onChange={(value) => {
                                            let n_form = form;
                                            n_form['content'] = value;
                                            setForm({...n_form});
                                        }}/>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Box>
                    <Box mt={5}>
                        <Button disabled={loading} variant='contained' color='primary' type="submit">ویرایش اطلاعات</Button>
                    </Box>
                </form>
            </Box>
        </Container>
    );
})

const mapStateToProps = state => ({
    authReducer : state.authReducer
})


export default connect(mapStateToProps)(ProductCategoryEdit);